export default "__VITE_ASSET__CAVx6al6__"